import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3C492F",
  d: "M6 14.307v-3.284h.773v1.97l2.53-2.53.541.54-2.53 2.531h1.97v.773zm5.003-4.463-.54-.54 2.53-2.531h-1.97V6h3.284v3.284h-.773v-1.97zM16.625 23q-.423 0-.81-.154a2.1 2.1 0 0 1-.697-.464L11.1 18.364l.29-.425a1.14 1.14 0 0 1 1.255-.464l1.855.502V11.41q0-.246.168-.413a.57.57 0 0 1 .415-.167q.247 0 .412.167t.164.413v8.114l-2.395-.638 2.688 2.689q.131.131.309.2.176.066.364.067h3.284q.811 0 1.372-.56.56-.56.56-1.372v-3.477a.56.56 0 0 1 .168-.413.57.57 0 0 1 .415-.167q.247 0 .412.167t.164.413v3.477q0 1.275-.908 2.183a2.98 2.98 0 0 1-2.183.908zm.328-5.602v-3.284a.56.56 0 0 1 .168-.413.57.57 0 0 1 .415-.167q.248 0 .412.167.165.165.165.413v3.284zm2.435 0v-2.512a.56.56 0 0 1 .167-.413.57.57 0 0 1 .415-.166q.249 0 .412.166.165.168.165.413v2.512z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }